import { useAppStore } from '../../../../store/appStore';
import { FlightUpload } from './flightUpload/FlightUpload';
import { stylesheet } from 'typestyle';
import { useHasAccessToProjectUpload } from '../useHasAccessToProjectUpload';
import { FlightUploadAlerts } from './flightUpload/FlightUploadAlerts';
import { GcpRequestUpload } from './gcpRequestUpload/GcpRequestUpload';

const css = stylesheet({
  uploads: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
});

export const MissionWindowUpload = () => {
  const { selectedMission } = useAppStore();
  const hasAccessToProjectUpload = useHasAccessToProjectUpload();

  if (!selectedMission) return null;

  const { customer, site, schedule, gcpPlacementService } = selectedMission;

  return (
    <div>
      <FlightUploadAlerts site={site} schedule={schedule} gcpPlacementService={gcpPlacementService} />

      <div className={css.uploads}>
        {(schedule || (hasAccessToProjectUpload && !gcpPlacementService)) && (
          <>
            <FlightUpload customer={customer} site={site} schedule={schedule} isPano={false} />
            <FlightUpload customer={customer} site={site} schedule={schedule} isPano={true} />
          </>
        )}

        <GcpRequestUpload
          customer={customer}
          site={site}
          gcpPlacementService={gcpPlacementService}
          schedule={schedule}
        />
      </div>
    </div>
  );
};
